export const allowedImageTypes = [
    'image/jpeg',
    'image/jpg', 
    'image/png',
    'image/webp',
    'image/svg+xml'
  ];
  
export const isValidImageType = (mimeType) => allowedImageTypes.includes(mimeType);

export const MAX_IMAGE_SIZE_MB = 2.8;

export const allowedFileTypes = [
    'application/pdf',
    // 'application/msword', // .doc
    // 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
    // 'application/vnd.ms-excel', // .xls
    // 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
  ];
  
  export const isValidFileType = (mimeType) => allowedFileTypes.includes(mimeType);
  
  export const MAX_FILE_SIZE_MB = 20;